export default __webpack_public_path__ + "static/media/FillRecommendation.7ffbb74c.svg";